import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=07fb0b03&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=ts&"
export * from "./Blog.vue?vue&type=script&lang=ts&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=07fb0b03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb0b03",
  null
  
)

export default component.exports